// extracted by mini-css-extract-plugin
export default {"root":"CommunitySettings_root__8oe1R","backButton":"CommunitySettings_backButton__gYXJC","menu":"CommunitySettings_menu__31z11"};